export default __webpack_public_path__ + "static/media/acaciatree.71981405.PNG";